// Progressive navigation for the audited Liquid home/product layouts. Shopify
// still renders every destination; unknown layouts and transaction routes stay native.
(() => {
  const reduced=matchMedia('(prefers-reduced-motion: reduce)');
  const root=document.documentElement, cache=new Map(), assets=new Map(), positions=new Map(), historyPages=new Map();
  const animations=new Set();let outgoing=null, sharedMotion=null, sequence=0, bypass=false, shownURL=location.href, warmTimer, shownKey;
  const main=()=>document.getElementById('MainContent');
  const handle=url=>new URL(url,location.href).pathname.match(/\/products\/([^/]+)/)?.[1];
  const artwork=image=>{try{return new URL(image.currentSrc||image.src,location.href).pathname.split('/').pop().replace('-mobile.webp','.webp')}catch{return ''}};
  const supportedURL=url=>url.origin===location.origin && /^\/(?:[a-z]{2}(?:-[A-Z]{2})?\/)?(?:$|products\/[^/]+\/?$|collections(?:\/|$)|pages\/|policies\/|blogs(?:\/|$)|search\/?$)/.test(url.pathname);
  const kind=node=>node?.querySelector('menasa-artistic-scroll')?'home':node?.querySelector('.menasa-product-page-root menasa-purchase,mc-piece')?'product':node?.children.length?'content':null;
  const managedScripts=new Set(['menasa-artistic-scroll.js','menasa-astrolabe.js','mc-chapter.js','menasa-chapters.js','menasa-heritage.js','menasa-pages.js','menasa-letter-v2.js','menasa-content-page.js','facets.js','dynamic-load-more.js','custom-select.js']);
  function imageFor(scope,id){
    if(!id)return null;
    const gallery=[...scope.querySelectorAll('menasa-gallery')].find(e=>e.dataset.productHandle===id);
    if(gallery)return gallery.querySelector('.is-active:not([hidden]) img');
    const chapter=scope.querySelector('mc-piece');
    if(chapter && (chapter.dataset.routeProduct||handle(shownURL))===id){
      const scroller=chapter.querySelector('[data-mc-scroller]');
      const slide=scroller && [...scroller.children].filter(slide=>!slide.hidden)[Math.round(scroller.scrollLeft/(scroller.clientWidth||1))];
      return slide?.querySelector('img');
    }
    const link=[...scope.querySelectorAll('a[href]')].find(a=>handle(a.href)===id&&a.querySelector('img'));
    return link?.querySelector('img');
  }
  const artBounds={
    'menasa-artistic-selected2-right.webp':[1148/1586,0,1,439/992],
    'menasa-artistic-selected2-near.webp':[0,692/992,336/1585,1],
    'menasa-artistic-model-extended.webp':[99/863,12/1822,819/863,1]
  };
  function visibleBounds(el){
    const image=el.matches('img')?el:el.querySelector('img');
    const bounds=image && artBounds[artwork(image)];
    if(!bounds)return el.getBoundingClientRect();
    const naturalWidth=image.naturalWidth || Number(image.getAttribute('width'));
    const naturalHeight=image.naturalHeight || Number(image.getAttribute('height'));
    if(!naturalWidth || !naturalHeight)return el.getBoundingClientRect();
    const r=image.getBoundingClientRect(),css=getComputedStyle(image);
    const fit=css.objectFit==='cover'?Math.max:Math.min;
    const scale=fit(r.width/naturalWidth,r.height/naturalHeight);
    const width=css.objectFit==='fill'?r.width:naturalWidth*scale;
    const height=css.objectFit==='fill'?r.height:naturalHeight*scale;
    const position=css.objectPosition.split(' ').map(v=>parseFloat(v)/100);
    const x=r.left+(r.width-width)*(Number.isFinite(position[0])?position[0]:.5);
    const y=r.top+(r.height-height)*(Number.isFinite(position[1])?position[1]:.5);
    return {left:x+width*bounds[0],right:x+width*bounds[2],top:y+height*bounds[1],bottom:y+height*bounds[3],width:width*(bounds[2]-bounds[0]),height:height*(bounds[3]-bounds[1])};
  }
  function imageBounds(image){
    const r=image.getBoundingClientRect(),css=getComputedStyle(image);
    if(css.objectFit!=='contain'||!image.naturalWidth||!image.naturalHeight)return r;
    const scale=Math.min(r.width/image.naturalWidth,r.height/image.naturalHeight);
    const width=image.naturalWidth*scale,height=image.naturalHeight*scale;
    const position=css.objectPosition.split(' ').map(v=>parseFloat(v)/100);
    const left=r.left+(r.width-width)*(Number.isFinite(position[0])?position[0]:.5);
    const top=r.top+(r.height-height)*(Number.isFinite(position[1])?position[1]:.5);
    return {left,top,right:left+width,bottom:top+height,width,height};
  }

  function participants(scope,exclude){
    const chosen=[];
    // The header is persistent and never moves. On phones, anything showing through its
    // transparent band (hero architecture, full-width media) only fades, so the navbar never
    // appears to slide in with the page.
    const band=innerWidth<850?(document.querySelector('#PrestigeHeader')?.getBoundingClientRect().bottom||0):0;
    const selectors='[data-motion-enter],.mc-pdp__bg > *,.mc-scroller,.mc-gal__zoom,.mc-gal__bar,.mc-gal__line,.mc-info > *,.mc-card__next,.mc-det__head,.mc-det__fig,.mc-lens,.mc-det__list,.mc-det__index,.mc-worn__copy,.mc-worn__scene,.mc-house__motto,.mc-house__pillars,.mc-house__ring,.menasa-product-info > *,.menasa-product-media,.hero__model-wrap,.scene-right,.scene-near,.hero__copy > *,.drop__intro,.piece__orbit,.piece__image,.piece__details,.material,.foreground,.garment-copy,.vault-title,product-card,h1,h2,.rte > *,menasa-content-page header > *,menasa-content-page article > *,menasa-content-page main > section > *, .menasa-club-coming-soon__content > *, .collection__grid > *,.cg-hero > *';
    for(const el of scope.querySelectorAll(selectors)){
      if(el===exclude||el.contains(exclude)||el.closest('[hidden],menasa-header,#PrestigeHeader,[role="banner"]')||chosen.some(r=>r.el.contains(el)))continue;
      const r=visibleBounds(el);
      if(!r.width||!r.height||r.bottom<=0||r.top>=innerHeight||r.right<=0||r.left>=innerWidth||el.closest('[data-occluded],.hero[data-offscreen]')||getComputedStyle(el).visibility==='hidden')continue;
      const side=el.dataset.motionEnter||(el.matches('.scene-near')||el.closest('.hero__copy')?'left':el.matches('.scene-right,.hero__model-wrap')?'right':null);
      const left=side==='left'||!side&&(r.left+r.right)/2<innerWidth/2;
      const css=getComputedStyle(el),start=css.translate==='none'?'0px 0px':css.translate;
      // The element's own resting filter (the hero's depth of field: the stone pillar rests at blur(4px)) stays in
      // both keyframes and the route's blur is added on top, so the element settles into its own focus instead of
      // arriving sharp and blurring when the animation ends. A filter with url() cannot interpolate: no filter motion.
      const veil=/url\(/.test(css.filter)?null:amount=>(css.filter==='none'?'':css.filter+' ')+`blur(${amount}px)`;
      chosen.push({el,start,fade:r.top<band&&!el.closest('.mc-scope'),veil,distance:left?-(r.right+24):innerWidth-r.left+24,blur:document.documentElement.dataset.effects==='light'?0:document.documentElement.dataset.effects==='balanced'?1:el.matches('.scene-layer,.hero__model-wrap,.menasa-product-media')?2:4});
      if(chosen.length===(scope.querySelector('.mc-scope')?32:10))break;
    }
    return chosen;
  }
  function animate(el,frames,options){
    const a=el.animate(frames,options);a.id='menasa-route';animations.add(a);
    a.finished.catch(()=>{}).finally(()=>{animations.delete(a);a.cancel()});return a;
  }
  function settle(){
    sharedMotion?.finish();
    for(const a of animations)a.cancel();animations.clear();
    outgoing?.remove();outgoing=null;
    document.querySelectorAll('[data-route-shared]').forEach(el=>el.removeAttribute('data-route-shared'));
  }
  function remember(){
    const key=window.navigation?.currentEntry?.key||shownKey;if(!key)return;
    positions.set(key,{x:scrollX,y:scrollY});
    if(positions.size>20)positions.delete(positions.keys().next().value);
  }
  function emitSections(node,type){
    node.querySelectorAll('.shopify-section').forEach(section=>section.dispatchEvent(new CustomEvent(type,{bubbles:true,detail:{sectionId:section.id.replace('shopify-section-','')}})));
  }
  function retainStyles(scope){
    for(const link of scope.querySelectorAll('link[rel="stylesheet"]')){
      const retained=[...document.head.querySelectorAll('link[rel="stylesheet"]')].find(node=>node.href===link.href&&node.media===link.media);
      if(retained)link.remove();else document.head.append(link);
    }
  }
  function resource(url,type){
    const absolute=new URL(url,location.href).href;
    if(assets.has(absolute))return assets.get(absolute);
    const existing=[...document.querySelectorAll(type==='style'?'link[rel="stylesheet"]':'script[src]')].find(e=>(e.href||e.src)===absolute);
    if(type==='style'&&existing&&existing.parentElement!==document.head)document.head.append(existing);
    if(existing && (type!=='style'||existing.sheet))return Promise.resolve();
    const promise=new Promise((resolve,reject)=>{
      const el=existing||document.createElement(type==='style'?'link':'script');
      const timer=setTimeout(()=>reject(new Error('Asset load timed out')),6000);
      el.addEventListener('load',()=>{clearTimeout(timer);resolve()},{once:true});
      el.addEventListener('error',()=>{clearTimeout(timer);reject(new Error('Asset load failed'))},{once:true});
      if(!existing){if(type==='style'){el.rel='stylesheet';el.href=absolute}else{el.src=absolute;el.async=true}document.head.append(el)}
    });assets.set(absolute,promise);promise.catch(()=>assets.delete(absolute));return promise;
  }
  const urlKey=url=>{const u=new URL(url,location.href);u.hash='';u.searchParams.delete('pb');return u.href};
  async function fetchPage(url,restore=false){
    const key=urlKey(url),cached=cache.get(key);
    if(restore&&historyPages.has(key))return historyPages.get(key);
    if(cached&&Date.now()-cached.at<30000)return cached.promise;
    const promise=(async()=>{
      // Keep this HTML request distinct from Chromium's speculative document
      // prefetch, which can otherwise hold it until a native navigation commits.
      const requestURL=new URL(key);requestURL.searchParams.set('_menasa_route','1');
      const response=await fetch(requestURL.href,{credentials:'same-origin',headers:{Accept:'text/html'},signal:AbortSignal.timeout?AbortSignal.timeout(12000):undefined});
      if(!response.ok||!response.headers.get('content-type')?.includes('text/html'))throw new Error('Document unavailable');
      if(new URL(response.url).pathname!==new URL(key).pathname)throw new Error('Use native redirect');
      const html=await response.text(),doc=new DOMParser().parseFromString(html,'text/html'),next=doc.getElementById('MainContent');
      if(!kind(next)||next.querySelector('.shopify-app-block,[name="selling_plan"]'))throw new Error('Unadapted layout');
      // Do not replay arbitrary document/merchant/app scripts into a live store.
    const scripts=[...next.querySelectorAll('script')].filter(s=>!s.type||/javascript|module/.test(s.type));
      if(scripts.some(s=>!s.src||!managedScripts.has(new URL(s.src).pathname.split('/').pop())))throw new Error('Unadapted page script');
      const page={html,title:doc.title};
      return page;
    })();
    cache.set(key,{promise,at:Date.now()});if(cache.size>4)cache.delete(cache.keys().next().value);
    promise.catch(()=>cache.delete(key));return promise;
  }
  function restore(page){
    const doc=new DOMParser().parseFromString(page.html,'text/html'),next=doc.getElementById('MainContent');
    next.querySelectorAll('script:not([type="application/json"]):not([type="application/ld+json"]),link[rel="stylesheet"]').forEach(el=>el.remove());
    return {doc,next};
  }
  async function prepare(page,url){
    const doc=new DOMParser().parseFromString(page.html,'text/html'),next=doc.getElementById('MainContent');
    const links=[...next.querySelectorAll('link[rel="stylesheet"]')];
    const scripts=[...next.querySelectorAll('script[src]')];
    await Promise.all([...links.map(link=>resource(link.href,'style')),...scripts.map(script=>resource(script.src,'script'))]);
    next.querySelectorAll('script:not([type="application/json"]):not([type="application/ld+json"]),link[rel="stylesheet"]').forEach(el=>el.remove());
    const images=[...next.querySelectorAll('.hero img,.mc-slide:first-child img,.menasa-gallery__slide:first-child img,img[loading="eager"]')].slice(0,8);
    await Promise.race([Promise.all(images.map(async img=>{
      // Respect picture art direction. Preloading img.src alone decoded desktop
      // backgrounds as well as the phone sources the real picture then selected.
      const source=[...img.parentElement.querySelectorAll('source[media]')].find(s=>matchMedia(s.media).matches);
      const image=new Image();image.sizes=source?.sizes||img.sizes;image.srcset=source?.srcset||img.srcset;image.src=img.src;await image.decode().catch(()=>{});
    })),new Promise(resolve=>setTimeout(resolve,2400))]);
    // Speculative fetches must not overwrite visited-page history snapshots.
    historyPages.set(urlKey(url),{html:page.html,title:doc.title});
    if(historyPages.size>4)historyPages.delete(historyPages.keys().next().value);
    return {doc,next};
  }
  function swap({doc,next},url,destination,type){
    const immediate=type==='traverse'||reduced.matches;
    const previous=main(),oldY=scrollY,oldX=scrollX;
    const chapter=next.querySelector('mc-piece');if(chapter)chapter.dataset.routeProduct=handle(url);
    const selected=handle(url)||handle(shownURL),source=sharedMotion && sharedMotion.id===selected?sharedMotion.image:imageFor(previous,selected);
    let target=imageFor(next,selected);
    const sourceRect=source&&imageBounds(source);
    const shared=!immediate&&source&&target&&source.complete&&sourceRect.bottom>0&&sourceRect.top<innerHeight&&artwork(source)===artwork(target);
    const leaving=immediate?[]:participants(previous,shared?(sharedMotion?.slot||source):null);
    // The navbar as the visitor saw it, before the outgoing page gives the header back: the heritage page opens on
    // its colour (assets/menasa-heritage.js).
    {const h=document.querySelector('#PrestigeHeader'),g=h?.querySelector('.site-header__glass');window.menasaRouteFrom={glass:g&&getComputedStyle(g,'::after').backgroundImage,ink:h&&getComputedStyle(h).color,type,at:performance.now()}}
    // The new navigation takes over immediately; no timer or animation can later
    // restore the previous route. Reading first retains the current visual image rect.
    settle();
    retainStyles(previous);
    emitSections(previous,'shopify:section:unload');
    previous.querySelectorAll('menasa-artistic-scroll').forEach(el=>el.cleanup?.());
    previous.querySelectorAll('video').forEach(video=>video.pause());
    // Read the navbar's current look before the destination restyles it.
    const header=document.querySelector('#PrestigeHeader'),glass=header?.querySelector('.site-header__glass');
    const fromGlass=glass&&getComputedStyle(glass,'::after').backgroundImage,fromInk=header&&getComputedStyle(header).color;
    const oldFooter=previous.nextElementSibling?.matches('[data-menasa-site-footer]')?previous.nextElementSibling:null;
    oldFooter?.remove();
    document.querySelector('menasa-header')?.close(false);
    document.querySelector('.menasa-arrival')?.remove();window.menasaRevealHero?.();
    // The landing page plays its reveals once per session (layout/theme.liquid); a later visit shows it as it was left.
    window.menasaHomeVisit?.(kind(next)==='home',type);
    root.classList.add('menasa-route-ready','menasa-route-dom');
    next.querySelector('.hero')?.classList.add('is-ready');
    if(shared){
      // Adopt the actual selected image into its permanent destination slot.
      // There is no floating copy and no opacity handoff at the end.
      for(const attr of [...source.attributes])source.removeAttribute(attr.name);
      for(const attr of target.attributes)source.setAttribute(attr.name,attr.value);
      source.dataset.routeShared='';
      // Keep the original node above both backgrounds while it travels. The
      // destination slot preserves layout; the same node occupies it on completion.
      source.remove();target.replaceWith(source);target=source;
    }
    previous.removeAttribute('id');previous.classList.add('menasa-route-outgoing');previous.inert=true;previous.setAttribute('aria-hidden','true');
    previous.style.cssText+=`;position:fixed;inset:auto;left:${-oldX}px;top:${-oldY}px;width:${document.documentElement.clientWidth}px;margin:0;pointer-events:none;z-index:20;`;
    previous.before(next);
    const footer=doc.querySelector('body > [data-menasa-site-footer]');if(footer)next.after(footer);
    for(const c of [...document.body.classList])if(c.startsWith('template--'))document.body.classList.remove(c);
    for(const c of doc.body.classList)if(c.startsWith('template--'))document.body.classList.add(c);
    document.body.toggleAttribute('data-artistic-home',kind(next)==='home');
    document.title=doc.title;
    for(const selector of ['link[rel="canonical"]','meta[name="description"]']){
      const incoming=doc.querySelector(selector),current=document.querySelector(selector);if(incoming&&current)current.replaceWith(incoming);
    }
    if(kind(next)!=='home')for(const name of ['--nav-rgb','--nav-ink','--header-top','--header-bottom','--journey-dark'])for(const el of [header,header?.querySelector('.site-header__glass')])el?.style.removeProperty(name);
    const saved=type==='traverse'?positions.get(destination.key):null;
    scrollTo({left:saved?.x||0,top:saved?.y||0,behavior:'instant'});
    if(!saved&&url.hash){try{next.querySelector(url.hash)?.scrollIntoView({behavior:'instant'})}catch{}}
    next.querySelectorAll('menasa-artistic-scroll').forEach(el=>el.refreshScene?.());
    window.MenasaImageFraming?.refresh(next);emitSections(next,'shopify:section:load');
    next.focus({preventScroll:true});shownURL=url.href;shownKey=destination.key;
    if(immediate){previous.remove();document.dispatchEvent(new CustomEvent('menasa:page',{detail:{url:url.href}}));return}
    outgoing=previous;
    const entering=participants(next,shared?target:null);
    const duration=1000,easing='cubic-bezier(.22,.68,.16,1)';
    const full=window.MenasaQuality?.tier==='full'&&!window.MenasaQuality?.noBlur;
    entering.forEach(({el,distance,blur,fade,veil},i)=>fade?animate(el,[{opacity:0},{opacity:1}],{duration:700,delay:Math.min(i*24,96),easing:'cubic-bezier(.22,.61,.36,1)',fill:'both'}):animate(el,[{translate:`${distance}px 0`,...(full&&veil?{filter:veil(blur)}:{})},{translate:'0px 0',...(full&&veil?{filter:veil(0)}:{})}],{duration,delay:Math.min(i*24,96),easing,fill:'both'}));
    leaving.forEach(({el,distance,blur,start,veil,fade})=>!fade&&animate(el,[{translate:start,...(full&&veil?{filter:veil(0)}:{})},{translate:`${parseFloat(start)+distance}px 0`,...(full&&veil?{filter:veil(blur)}:{})}],{duration:560,easing:'cubic-bezier(.4,0,.6,1)',fill:'both'}));
    // The navbar never goes see-through: its previous background is laid over the new one
    // and dissolves into it, and its ink colour blends to the destination's.
    if(glass&&fromGlass&&fromGlass!=='none'){
      const from=document.createElement('div');from.setAttribute('aria-hidden','true');
      // The theme hides empty divs, so the layer must be displayed explicitly.
      from.style.cssText=`display:block;position:absolute;inset:0;z-index:0;pointer-events:none;background:${fromGlass};`;
      glass.after(from);
      animate(from,[{opacity:1},{opacity:0}],{duration:700,easing:'cubic-bezier(.4,0,.2,1)',fill:'both'}).finished.catch(()=>{}).finally(()=>from.remove());
    }
    const toInk=header&&getComputedStyle(header).color;
    if(toInk&&fromInk&&toInk!==fromInk)animate(header,[{color:fromInk},{color:toInk}],{duration:700,easing:'cubic-bezier(.4,0,.2,1)'});
    const fade=animate(previous,[{opacity:1},{opacity:0}],{duration:680,easing:'cubic-bezier(.4,0,.2,1)',fill:'both'});
    fade.finished.catch(()=>{}).finally(()=>{previous.remove();if(outgoing===previous)outgoing=null});
    if(shared){
      const to=imageBounds(target),originalStyle=source.getAttribute('style');
      const slot=target.cloneNode();slot.style.visibility='hidden';target.before(slot);
      source.style.cssText=`position:absolute;left:${to.left+scrollX}px;top:${to.top+scrollY}px;width:${to.width}px;height:${to.height}px;max-width:none;max-height:none;margin:0;object-fit:contain;transform:none;transform-origin:0 0;pointer-events:none;z-index:100;`;
      document.body.append(source);
      const record={id:selected,image:source,slot,finish(){
        if(sharedMotion!==record)return;
        sharedMotion=null;record.animation?.cancel();
        if(originalStyle===null)source.removeAttribute('style');else source.setAttribute('style',originalStyle);
        source.removeAttribute('data-route-shared');slot.replaceWith(source);
      }};sharedMotion=record;
      const a=animate(source,[{translate:`${sourceRect.left-to.left}px ${sourceRect.top-to.top}px`,scale:`${sourceRect.width/to.width} ${sourceRect.height/to.height}`},{translate:'0px 0px',scale:'1 1'}],{duration,easing,fill:'both'});
      record.animation=a;
      a.finished.catch(()=>{}).finally(()=>record.finish());
    }
    document.dispatchEvent(new CustomEvent('menasa:page',{detail:{url:url.href}}));
  }
  async function navigateTo(url,destination,type,token,signal){
    try{
      if(type==='traverse')settle();
      if(urlKey(url)===urlKey(shownURL)){settle();const saved=type==='traverse'?positions.get(destination.key):null;scrollTo({left:saved?.x||0,top:saved?.y||0,behavior:type==='traverse'||reduced.matches?'instant':'smooth'});shownKey=destination.key;shownURL=url.href;return}
      const remembered=type==='traverse'&&historyPages.get(urlKey(url));
      if(remembered){swap(restore(remembered),url,destination,type);return}
      root.classList.add('menasa-route-loading');
      const page=await fetchPage(url,type==='traverse'),prepared=await prepare(page,url);
      if(signal?.aborted||token!==sequence)return;
      swap(prepared,url,destination,type);
      if(kind(main())==='product')cache.delete(urlKey(url));
    }catch(error){
      if(signal?.aborted||token!==sequence)return;
      bypass=true;location.replace(url.href);
    }finally{if(token===sequence)root.classList.remove('menasa-route-loading')}
  }
  function init(){
    if(window.Shopify?.designMode||!kind(main()))return;
    retainStyles(main());
    root.classList.add('menasa-router-ready');
    historyPages.set(urlKey(shownURL),{html:document.documentElement.outerHTML,title:document.title});
    // Native cross-document snapshots are intentionally disabled: real destination
    // nodes remain scrollable and clickable throughout Web Animations API motion.
    if(window.navigation)window.navigation.addEventListener('navigate',event=>{
      const url=new URL(event.destination.url);
      if(url.searchParams.has('preview_theme_id')&&Number(url.searchParams.get('preview_theme_id'))!==window.Shopify?.theme?.id)return;
      // A script updating the address bar of this page (history.replaceState/pushState) is not a visit.
      if(event.destination.sameDocument&&!event.userInitiated&&event.navigationType!=='traverse')return;
      if(bypass||!event.canIntercept||event.hashChange||event.formData||event.downloadRequest!==null||event.navigationType==='reload'||!supportedURL(url)||!kind(main()))return;
      remember();const token=++sequence;
      event.intercept({scroll:'manual',focusReset:'manual',handler:()=>navigateTo(url,event.destination,event.navigationType,token,event.signal)});
    });
    else {
      const key=()=>crypto.randomUUID?crypto.randomUUID():Math.random().toString(36).slice(2)+Date.now().toString(36);
      shownKey=history.state?.menasaRouteKey||key();
      history.replaceState({...history.state,menasaRouteKey:shownKey},'');
      history.scrollRestoration='manual';
      document.addEventListener('click',event=>{
        const link=event.target.closest?.('a[href]');
        if(event.defaultPrevented||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey||!link||link.hasAttribute('download')||link.target&&link.target!=='_self')return;
        const url=new URL(link.href);
        if(!supportedURL(url)||urlKey(url)===urlKey(shownURL)&&url.hash||!kind(main()))return;
        if(url.searchParams.has('preview_theme_id')&&Number(url.searchParams.get('preview_theme_id'))!==window.Shopify?.theme?.id)return;
        event.preventDefault();remember();const destination={key:key()};
        history.pushState({menasaRouteKey:destination.key},'',url);
        navigateTo(url,destination,'push',++sequence);
      });
      addEventListener('popstate',event=>{
        remember();const token=++sequence,url=new URL(location.href);
        if(!event.state?.menasaRouteKey||!supportedURL(url)){location.reload();return}
        navigateTo(url,{key:event.state.menasaRouteKey},'traverse',token);
      });
    }
    function warm(event){
      const link=event.target.closest?.('a[href]');if(!link||navigator.connection?.saveData||event.pointerType==='touch')return;
      const url=new URL(link.href);if(!supportedURL(url)||urlKey(url)===urlKey(shownURL))return;
      clearTimeout(warmTimer);warmTimer=setTimeout(()=>fetchPage(url).catch(()=>{}),70);
    }
    document.addEventListener('pointerover',warm,{passive:true});document.addEventListener('focusin',warm);
    document.addEventListener('pointerdown',event=>{if(event.target.closest('menasa-gallery,.mc-gal'))sharedMotion?.finish()},{capture:true});
    addEventListener('resize',()=>sharedMotion?.finish(),{passive:true});
    // Only warm the two visible editorial product routes after initial rendering.
    const idle=window.requestIdleCallback||((fn)=>setTimeout(fn,500));
    idle(()=>{if(!navigator.connection?.saveData&&window.MenasaQuality?.tier==='full')main()?.querySelectorAll('.piece__visual[href]').forEach(a=>fetchPage(a.href).catch(()=>{}))});
    reduced.addEventListener('change',()=>{if(reduced.matches)settle()});
    addEventListener('pagehide',()=>{remember();settle()});
  }
  function arrive(){
    const intro=document.querySelector('.menasa-arrival');
    if(!intro||reduced.matches||window.Shopify?.designMode||scrollY>80||root.classList.contains('menasa-home-seen')||performance.getEntriesByType('navigation')[0]?.type==='back_forward'){intro?.remove();window.menasaRevealHero?.();return}
    // Hold a readable wordmark on the initial visit; internal routes never recreate it.
    const heroImages=[...(main()?.querySelectorAll('.hero img')||[])];
    const ready=Promise.allSettled(heroImages.map(image=>image.decode()));
    // Decode only the first scene behind the curtain, bounded for slow networks.
    // Keep the minimum wordmark hold; do not reveal a half-decoded hero.
    Promise.all([new Promise(resolve=>setTimeout(resolve,1400)),Promise.race([ready,new Promise(resolve=>setTimeout(resolve,2400))])]).then(()=>{
      if(!intro.isConnected)return;
      window.menasaRevealHero?.();intro.classList.add('is-leaving');setTimeout(()=>intro.remove(),850);
    });
  }
  const start=()=>{init();arrive()};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
